import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';

class SubEtapaProyectoService {
	static Listar = (filtro, paginacion) => {
		let params = {
		filtro: {
			area_proyecto: filtro.area_proyecto || null,
			etapa: filtro.etapa || null,
			subetapa: filtro.subetapa || null,
			activo: (Number(filtro.activo) === 1 || Number(filtro.activo) === 0) ? Number(filtro.activo) : 'all',
		},
		paginacion: {
			total: paginacion.total || null,
			page: paginacion.page || null,
			limit: paginacion.limit || null
		}
	};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_SubEtapa_Proyecto_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	};
	static Agregar = (form) => {
		let params = {
			id_cat_subetapa_proyecto: null,
			id_cat_etapa_proyecto: form.id_cat_etapa_proyecto || '',
			id_cat_area_proyecto: form.id_cat_area_proyecto || '',
			etapa: form.etapa || '',
			subetapa: form.subetapa || '',
			descripcion: form.descripcion || '',
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_SubEtapa_Proyecto_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	};
	static Modificar = (form) => {
		let params = {
			id_cat_subetapa_proyecto: form.id_cat_subetapa_proyecto || '',
			id_cat_etapa_proyecto: form.id_cat_etapa_proyecto || '',
			id_cat_area_proyecto: form.id_cat_area_proyecto || '',
			etapa: form.etapa || '',
			subetapa: form.subetapa || '',
			descripcion: form.descripcion || '',
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_SubEtapa_Proyecto_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	};
	static Eliminar = (id_cat_subetapa_proyecto) => {
		let params = {
			id_cat_subetapa_proyecto: id_cat_subetapa_proyecto
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_SubEtapa_Proyecto_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	};
}

export default SubEtapaProyectoService;
